import { Component, Input } from '@angular/core';
import { TransactionStatus } from 'common';
import { BrokerStatus } from '@partner/shared/SharedConstants';
import { LoanInitialDrawData } from '../../../../../../domain/models/loan.model';

@Component({
    selector: 'ifbp-activated-details-draw-section',
    templateUrl: './activated-details-draw-section.component.html',
    styleUrls: ['./activated-details-draw-section.component.scss'],
    standalone: false
})
export class ActivatedDetailsDrawSectionComponent {
  readonly TransactionStatus = TransactionStatus;
  readonly BrokerStatus = BrokerStatus;

  @Input()
  brokerStatus: BrokerStatus;

  @Input()
  transactionStatusLabel: Map<TransactionStatus, string>;;

  @Input()
  draws?: LoanInitialDrawData[];

  trackByIndex(index: number): number {
    return index;
  }
}
